import { FormBase } from "../../../util/form-base-form";

class ProductLikeForm extends FormBase {
    public getIcon(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "i.bi", HTMLElement);
    }
}

const productLikeForm = new ProductLikeForm();

export { productLikeForm };
